export function getBankName(bankCode?: string): string {
  if (!bankCode) return "";

  switch (bankCode) {
    case "03":
      return "기업은행";
    case "07":
      return "수협";
    case "23":
      return "SC제일은행";
    case "34":
      return "광주은행";
    case "39":
      return "경남은행";
    case "04":
      return "국민은행";
    case "11":
      return "농협";
    case "26":
      return "신한은행";
    case "71":
      return "우체국";
    case "20":
      return "우리은행";
    case "32":
      return "부산은행";
    case "81":
      return "KEB하나은행";
    case "31":
      return "IM뱅크";
    default:
      return ""; // 일치하는 코드가 없을 때 기본값으로 빈 문자열 반환
  }
}
